export const STATE = 'warranty.components.address_form.state';
export const NO_SUCH_STATE =
  'warranty.components.address_form.state_no_results';

export const ADDRESS_FORM_FIRST_NAME =
  'warranty.components.address_form.first_name';
export const ADDRESS_FORM_LAST_NAME =
  'warranty.components.address_form.last_name';
export const ADDRESS_FORM_ADDRESS1 =
  'warranty.components.address_form.address1';
export const ADDRESS_FORM_ADDRESS2 =
  'warranty.components.address_form.address2';
export const ADDRESS_FORM_CITY = 'warranty.components.address_form.city';
export const ADDRESS_FORM_STATE = 'warranty.components.address_form.state';
export const ADDRESS_FORM_ZIPCODE = 'warranty.components.address_form.zipcode';
export const ADDRESS_FORM_PHONE = 'warranty.components.address_form.phone';
export const ADDRESS_FORM_COMPANY = 'common.forms.address.company';
export const ADDRESS_FORM_COMPANYREQUEST =
  'common.forms.address.company_request';
export const ADDRESS_FORM_NAMELOCKED = 'common.forms.address.name_locked';
export const ADDRESS_FORM_DEFAULT = 'common.forms.address.default';
export const ADDRESS_FORM_DELETE = 'common.generic.delete';
export const ADDRESS_FORM_SAVE = 'common.modals.confirm';
export const ADDRESS_FORM_SPECIAL_INSTRUCTIONS =
  'common.forms.address.special_instructions';
